// extracted by mini-css-extract-plugin
export default {"portfolioWrap":"Portfolio_portfolioWrap__hcDWw","portContentWrap":"Portfolio_portContentWrap__-PWc4"};